module.exports = __webpack_public_path__ + "static/img/Update_Profile_and_Information.59553d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Update_Profile_and_Information.jpg
// module id = rBDM
// module chunks = 7